import { QUOTE_FUNNEL } from 'helpers/sf_constants';
import React from 'react';
import InputComponent from './Components/InputComponent';
import DefaultComponent from './Components/DefaultComponent';
import DateTimeComponent from './Components/DateTimeComponent';
import SelectComponent from './Components/SelectComponent';
import SelectWithDisplay from './Components/SelectWithDisplay';
import CheckBoxComponent from './Components/CheckBoxComponent';
import EmailComponent from './Components/EmailComponent';
import PhoneComponent from './Components/PhoneNumberComponent';
import AddressAutoFillComponent from './Components/AddressAutoFillComponent';


const Question = (props) => {
  switch (props?.question?.question_type) {
    case QUOTE_FUNNEL.COMPONENT_TYPE.TEXT:
      return (
        <InputComponent {...props} />
      )
    case QUOTE_FUNNEL.COMPONENT_TYPE.NUMBER:
      return (
        <InputComponent {...props} />
      )
    case QUOTE_FUNNEL.COMPONENT_TYPE.EMAIL:
      return (
        <EmailComponent {...props} />
      )
    case QUOTE_FUNNEL.COMPONENT_TYPE.PHONE_NUMBER:
      return (
        <PhoneComponent {...props} />
      )
    case QUOTE_FUNNEL.COMPONENT_TYPE.DATE:
      return (
        <DateTimeComponent {...props} />
      )
    case QUOTE_FUNNEL.COMPONENT_TYPE.SELECT_BOX:
      return (
        <SelectComponent {...props} />
      )
    case QUOTE_FUNNEL.COMPONENT_TYPE.BOOLEAN_WITH_DISPLAY:
      return (
        <SelectWithDisplay {...props} />
      )
    case QUOTE_FUNNEL.COMPONENT_TYPE.MULTI_SELECT:
      return (
        <CheckBoxComponent {...props} />
      )
    case QUOTE_FUNNEL.COMPONENT_TYPE.ADDRESS:
      return (
        <AddressAutoFillComponent {...props} />
      )
    default:
      return (
        <DefaultComponent {...props} />
      )
  }
}
export default Question;
